import {
    UPLOADSAMPLEFILEOFDEALERDSRLIMIT_SUCCESS,
    UPLOADSAMPLEFILEOFDEALERDSRLIMIT_FAILED,
    RESET_UPLOADSAMPLEFILEOFDEALERDSRLIMIT,
    LOADING_UPLOADSAMPLEFILEOFDEALERDSRLIMIT,
    NETWORK_ERROR_UPLOADSAMPLEFILEOFDEALERDSRLIMIT
} from '../types/index';
import { dealerServices } from "../../config/axios";

const resetUploadSampleFileOfDealerDsrLimit = () => {
    return { type: RESET_UPLOADSAMPLEFILEOFDEALERDSRLIMIT };
};

const uploadSampleFileOfDealerDsrLimitapi =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_UPLOADSAMPLEFILEOFDEALERDSRLIMIT });
        await dealerServices
            .post("uploadDsr", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "Success":
                        dispatch(uploadSampleFileOfDealerDsrLimitsuccess(res.data));
                        break;
                    default:
                        dispatch(uploadSampleFileOfDealerDsrLimitFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_UPLOADSAMPLEFILEOFDEALERDSRLIMIT,
                    payload: err,
                });
            });
    };

function uploadSampleFileOfDealerDsrLimitsuccess(data) {
    return {
        type: UPLOADSAMPLEFILEOFDEALERDSRLIMIT_SUCCESS,
        payload: data,
    };
}

function uploadSampleFileOfDealerDsrLimitFailed(data) {
    return {
        type: UPLOADSAMPLEFILEOFDEALERDSRLIMIT_FAILED,
        payload: data,
    };
}

export { resetUploadSampleFileOfDealerDsrLimit, uploadSampleFileOfDealerDsrLimitapi }